module.exports = __webpack_public_path__ + "static/media/saved1.f9faced0.png";